import { render, staticRenderFns } from "./CalendarGeneralSettings.vue?vue&type=template&id=ffb6199e"
import script from "./CalendarGeneralSettings.vue?vue&type=script&lang=js"
export * from "./CalendarGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports